import axios from './../api' // 倒入 api
export const user = {
  // 登录接口
  loginApi: data => {
    return axios({
      url: '/huizb-app/appLogin/mobileVerifyLogin',
      method: 'post',
      base: 'ZBID',
      data
    })
  },
  // core登录接口
  loginCoreApi: data => {
    return axios({
      url: '/huizb-app/appUser/UserOrgContent/getHuiCoreOpenApiToken',
      method: 'post',
      base: 'ZBID',
      data
    })
  },
  // 滙签预登录
  huiSignLogin: data => {
    return axios({
      url: '/huizb-app/huiSign/huiSignLogin',
      method: 'post',
      base: 'ZBID',
      data
    })
  },
  // 获取短信验证码
  getMSMCode: data => {
    return axios({
      url: '/huizb-app/verify/sendMobileVerifyCode',
      method: 'post',
      base: 'ZBID',
      data
    })
  },
  // 刷新token
  getHuiCoreToken: data => {
    return axios({
      url: '/hui-xypt/appUser/getHuiCoreToken',
      method: 'post',
      base: 'BASE',
      data
    })
  },
  // 用户数据
  userInfo: params => {
    return axios({
      url: '/huizb-app/approve/getMyApprove',
      method: 'post',
      base: 'ZBID'
    })
  },
  // Vip数据
  vipInfo: params => {
    return axios({
      url: '/huizb-app/myVip/selectMyVip',
      method: 'post',
      base: 'ZBID'
    })
  },
  // 获取企业信誉分
  scoreInfo: params => {
    return axios({
      url: '/huizb-app/orgContent/selectBaseDetail',
      method: 'get',
      base: 'ZBID',
      params
    })
  },
  // 法人认证
  getFaceUrl: data => {
    return axios({
      url: '/huizb-app/ysface/getFaceUrl',
      method: 'post',
      base: 'ZBID',
      loading: true,
      data
    })
  },
  // 法人认证
  addApprove: (data, url) => {
    return axios({
      url: url,
      method: 'post',
      base: 'ZBID',
      loading: true,
      data
    })
  },
  // 法人认证结果
  getFaceResult: data => {
    return axios({
      url: '/huizb-app/ysface/getFaceResult',
      method: 'post',
      base: 'ZBID',
      hideMsg: true,
      data
    })
  },
  // 切换企业
  switchUsersOrgInfo: data => {
    return axios({
      url: '/huizb-app/appUser/UserOrgContent/switchUsersOrgInfo',
      method: 'post',
      base: 'ZBID',
      loading: true,
      data
    })
  },
  // 上传
  getUploadFileUrl: data => {
    return axios({
      url: '/huizb-app/appFile/getUploadFileUrl',
      method: 'post',
      base: 'ZBID',
      data
    })
  },
}

export default user
